<template>
  <el-card class="main-card">
    <template #header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>库存管理</el-breadcrumb-item>
      </el-breadcrumb>
    </template>

    <el-divider content-position="left">库存单据管理</el-divider>
    <el-row style="min-width:320px">
      <el-col :xs="12" :sm="6" :md="3" :lg="3" :xl="3">
        <div class="el-result" @click="openPage('/stock/bills/inlist')">
          <div class="el-result__icon">
            <el-icon style="font-size: 3em; color: #67c23a;">
              <Download />
            </el-icon>
          </div>
          <div class="el-result__title">
            <p>货品入库</p>
          </div>
          <div class="el-result__subtitle">
            <p>操作入库单据，记录货品入库信息</p>
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="6" :md="3" :lg="3" :xl="3">
        <div class="el-result" @click="openPage('/stock/bills/index')">
          <div class="el-result__icon">
            <el-icon style="font-size: 3em; color: #e6a23c;">
              <Upload />
            </el-icon>
          </div>
          <div class="el-result__title">
            <p>货品出库</p>
          </div>
          <div class="el-result__subtitle">
            <p>操作出库单据，记录货品出库信息</p>
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="6" :md="3" :lg="3" :xl="3">
        <div class="el-result" @click="openPage('/stock/bills/调拨')">
          <div class="el-result__icon">
            <el-icon style="font-size: 3em; color: #409eff;">
              <Position />
            </el-icon>
          </div>
          <div class="el-result__title">
            <p>库存调拨</p>
          </div>
          <div class="el-result__subtitle">
            <p>货品调拨单据，仓库间货品调拨</p>
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="6" :md="3" :lg="3" :xl="3">
        <div class="el-result" @click="openPage('/stock/bills/借货')">
          <div class="el-result__icon">
            <el-icon style="font-size: 3em; color: rgb(194, 0, 232);">
              <Connection />
            </el-icon>
          </div>
          <div class="el-result__title">
            <p>借货申请</p>
          </div>
          <div class="el-result__subtitle">
            <p>货品借货申请单据管理</p>
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="6" :md="3" :lg="3" :xl="3">
        <div class="el-result" @click="openPage('/stock/bills/assemble')">
          <div class="el-result__icon">
            <el-icon style="font-size: 3em; color: rgb(0, 143, 108);">
              <SetUp />
            </el-icon>
          </div>
          <div class="el-result__title">
            <p>成品组装/拆分</p>
          </div>
          <div class="el-result__subtitle">
            <p>成品组装/拆分单据</p>
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="6" :md="3" :lg="3" :xl="3">
        <div class="el-result" @click="openPage('/stock/bills/repair')">
          <div class="el-result__icon">
            <el-icon style="font-size: 3em; color: #ff8a00;">
              <Tools />
            </el-icon>
          </div>
          <div class="el-result__title">
            <p>维修管理</p>
          </div>
          <div class="el-result__subtitle">
            <p>借货维修出库与维修入库审批</p>
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="6" :md="3" :lg="3" :xl="3">
        <div class="el-result" @click="openPage('/stock/bills/gold')">
          <div class="el-result__icon">
            <el-icon style="font-size: 3em; color: #b78a00;">
              <Money />
            </el-icon>
          </div>
          <div class="el-result__title">
            <p>融金出库</p>
          </div>
          <div class="el-result__subtitle">
            <p>借货融金申请、财务复核与出库</p>
          </div>
        </div>
      </el-col>
      <!-- <el-col :xs="12" :sm="6" :md="3" :lg="3" :xl="3">
        <div class="el-result" @click="openPage('/stock/bills/assembleSplit')">
          <div class="el-result__icon">
            <el-icon style="font-size: 3em; color: gold;">
              <ScaleToOriginal />
            </el-icon>
          </div>
          <div class="el-result__title">
            <p>成品拆分</p>
          </div>
          <div class="el-result__subtitle">
            <p>成品拆分单据，拆分已组装成品</p>
          </div>
        </div>
      </el-col> -->
      <el-col :xs="12" :sm="6" :md="3" :lg="3" :xl="3">
        <div class="el-result" @click="openPage('/stock/check/index')">
          <div class="el-result__icon">
            <el-icon style="font-size: 3em; color: #f56c6c;">
              <DocumentChecked />
            </el-icon>
          </div>
          <div class="el-result__title">
            <p>库存盘点</p>
          </div>
          <div class="el-result__subtitle">
            <p>库存盘点单据，核对实际库存</p>
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="6" :md="3" :lg="3" :xl="3">
        <div class="el-result" @click="openPage('/order/preInfo30')">
          <div class="el-result__icon">
            <el-icon style="font-size: 3em; color: #909399;">
              <ShoppingCart />
            </el-icon>
          </div>
          <div class="el-result__title">
            <p>出库订单</p>
          </div>
          <div class="el-result__subtitle">
            <p>客户销售出库的订单管理</p>
          </div>
        </div>
      </el-col>
    </el-row>

    <el-divider content-position="left">库存查询统计</el-divider>
    <el-row style="min-width:320px;">
      <el-col :xs="12" :sm="6" :md="3" :lg="3" :xl="3">
        <div class="el-result" @click="openPage('/stock/bound/index')">
          <div class="el-result__icon">
            <el-icon style="font-size: 3em; color:#67c23a;">
              <Box />
            </el-icon>
          </div>
          <div class="el-result__title">
            <p>在库库存</p>
          </div>
          <div class="el-result__subtitle">
            <p>查看库存明细，当前在库货品统计</p>
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="6" :md="3" :lg="3" :xl="3">
        <div class="el-result" @click="openPage('/stock/bound/0')">
          <div class="el-result__icon">
            <el-icon style="font-size: 3em; color: rgb(68 63 169);">
              <Tickets />
            </el-icon>
          </div>
          <div class="el-result__title">
            <p>出库明细</p>
          </div>
          <div class="el-result__subtitle">
            <p>明细货品的出库情况</p>
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="6" :md="3" :lg="3" :xl="3">
        <div class="el-result" @click="openPage('/stock/bound/2')">
          <div class="el-result__icon">
            <el-icon style="font-size: 3em; color: gold;">
              <ScaleToOriginal />
            </el-icon>
          </div>
          <div class="el-result__title">
            <p>入库明细</p>
          </div>
          <div class="el-result__subtitle">
            <p>明细货品的入库情况</p>
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="6" :md="3" :lg="3" :xl="3">
        <div class="el-result" @click="openPage('/stock/report/sellreport')">
          <div class="el-result__icon">
            <el-icon style="font-size: 3em; color: rgb(11, 168, 0);">
              <DataAnalysis />
            </el-icon>
          </div>
          <div class="el-result__title">
            <p>销售统计</p>
          </div>
          <div class="el-result__subtitle">
            <p>货品销售情况统计报表</p>
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="6" :md="3" :lg="3" :xl="3">
        <div class="el-result" @click="openPage('/stock/report/boundday')">
          <div class="el-result__icon">
            <el-icon style="font-size: 3em; color: rgb(255, 0, 0);">
              <Files />
            </el-icon>
          </div>
          <div class="el-result__title">
            <p>历史库存管理</p>
          </div>
          <div class="el-result__subtitle">
            <p>历史库存的款式统计</p>
          </div>
        </div>
      </el-col>
      <!-- <el-col :xs="12" :sm="6" :md="3" :lg="3" :xl="3">
        <div class="el-result" @click="openPage('/stock/report/sellreport')">
          <div class="el-result__icon">
            <el-icon style="font-size: 3em; color: rgb(69, 52, 254);">
              <TrendCharts />
            </el-icon>
          </div>
          <div class="el-result__title">
            <p>销售报表</p>
          </div>
          <div class="el-result__subtitle">
            <p>货品销售/退货等情况统计报表</p>
          </div>
        </div>
      </el-col> -->
    </el-row>

    <!-- <el-divider content-position="left">货品基础资料</el-divider>
    <el-row style="min-width:320px;">
      <el-col :xs="12" :sm="6" :md="3" :lg="3" :xl="3">
        <div class="el-result" @click="openPage('/stock/product/spulist')">
          <div class="el-result__icon">
            <el-icon style="font-size: 3em; color:#409eff;">
              <Goods />
            </el-icon>
          </div>
          <div class="el-result__title">
            <p>货品SPU</p>
          </div>
          <div class="el-result__subtitle">
            <p>货品标准单位管理</p>
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="6" :md="3" :lg="3" :xl="3">
        <div class="el-result" @click="openPage('/stock/product/skulist')">
          <div class="el-result__icon">
            <el-icon style="font-size: 3em; color: rgb(230, 162, 60);">
              <GoodsFilled />
            </el-icon>
          </div>
          <div class="el-result__title">
            <p>货品SKU</p>
          </div>
          <div class="el-result__subtitle">
            <p>货品库存单位管理</p>
          </div>
        </div>
      </el-col>
    </el-row> -->
  </el-card>
</template>

<script>
export default {
  name: "StockApplication",
  components: {},
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {
    openPage(path) {
      if (path) {
        this.$router.push(path);
      }
    }
  },
};
</script>
<style scoped>
.el-result {
  margin: 0 12px;
  border: 1px solid #fff;
  --el-result-padding: 10px;
  --el-result-title-margin-top:10px;
  --el-result-icon-font-size:null;
  background: #fcfcfc;
}

.el-result:hover {
  border: 1px solid #ccc;
  border-radius: 10px;
  cursor: pointer;
}

.el-divider >>> .el-divider__text {
  font-size: 18px;
}
</style>
